'use client'

import React from 'react'

import whereToWatchStyle from '../../styles/components/homePage/where_to_watch.js'
import Title from '../HomePage/Title'
import Platform from './Platform'

const WhereToWatch = ({ platforms, title, className }) => {
  return (
    <>
      <div className='wtw-wrapper'>
        <Title title={title} />
        <div className='platforms-container'>
          {platforms?.map(platform => (
            <Platform key={platform?.url} platform={platform} className={className} />
          ))}
        </div>
      </div>
      <style jsx>{whereToWatchStyle}</style>
    </>
  )
}

export default WhereToWatch
